var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Basemaintain"},[_c('iframe',{staticStyle:{"width":"100%","height":"calc(100vh - 65px)"},attrs:{"id":"bdIframe","src":_vm.url,"frameborder":"0"}})])}
var staticRenderFns = []

export { render, staticRenderFns }